<script>
  import IconLoaderCircle from "lucide-svelte/icons/loader-circle";

  let {
        class: classInput,
        ref = $bindable(null),
        children,
        ...restProps
      } = $props();

  let bIsTest = true;
</script>

<IconLoaderCircle style="color: #a8a7a7; width: 3rem; height: 3rem;" class="animate-spin"/>

<style>
  :global(.animate-spin) {
    animation: spin 1s linear infinite;
  }

  @keyframes -global-spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>

